import { render, staticRenderFns } from "./zgfhxsc.vue?vue&type=template&id=6ed4a7d3&scoped=true"
import script from "./zgfhxsc.vue?vue&type=script&lang=js"
export * from "./zgfhxsc.vue?vue&type=script&lang=js"
import style0 from "./zgfhxsc.vue?vue&type=style&index=0&id=6ed4a7d3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed4a7d3",
  null
  
)

export default component.exports